import { Subscription } from 'rxjs';
import Swal from 'sweetalert2';
import { ContaService } from './../../services/financeiro/conta.service';
import { DatePipe } from '@angular/common';
import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import * as jsPDF from 'jspdf';
import 'jspdf-autotable';
import { AuthService } from 'src/app/services/vos/auth.service';
import { GerarPdfOsService } from 'src/app/services/utils/gerar-pdf-os.service';

@Component({
  selector: 'app-visualizar-medicao',
  templateUrl: './visualizar-medicao.component.html',
  styleUrls: ['./visualizar-medicao.component.css']
})
export class VisualizarMedicaoComponent implements OnInit {
  usuario: any
  logo: any = [];
  contas: any;
  inscricao: Subscription;
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<VisualizarMedicaoComponent>,
    private authService: AuthService,
    private contaService: ContaService,
    private pdfService: GerarPdfOsService
  ) { }

  ngOnInit() {
    this.pegarUsuario()
  }
  pegarUsuario() {
    this.usuario = JSON.parse(this.authService.getUserLoggedIn())
    if (this.usuario?.user.pessoa.profissional) this.logo = this.usuario.user.pessoa.profissional.empresa
    if (this.usuario?.user.pessoa.cliente) this.logo = this.usuario.user.pessoa.cliente.empresa
    if (this.usuario?.user.pessoa.responsavel) this.logo = this.usuario.user.pessoa.responsavel.empresa
  }

  gerarContaPagar() {

    let conta = {
      id: "",
      empresa_id: this.usuario.user.pessoa.profissional.empresa_id,
      conta_id: "",
      contasbancaria_id: "",
      numeroboleto: "",
      formapagamento: "",
      datavencimento: "",
      datapagamento: "",
      valorconta: this.data.valor,
      status: false,
      tipopagamento: "A Vista",
      valorpago: "",
      pagamentoparcial: 0,
      observacao: "",
      numeroconta: "",
      anexo: ""
    }


    this.contas = {
      id: "",
      empresa_id: this.usuario.user.pessoa.profissional.empresa_id,
      tipopessoa: "Cliente",
      pessoa_id: this.data.cliente.id,
      natureza_id: "",
      valortotalconta: this.data.valor,
      tipoconta: "Pagar",
      historico: "",
      status: false,
      nfe: '',
      quantidadeconta: 1,
      valorpago: "",
      tipocontapagamento: "A Vista",
      dataemissao: this.data.dataSolicitacao,
      dataemissaofim: "",
      datavencimento: "",
      datavencimentofim: "",
      pagamentos: []
    }

    this.contas.pagamentos.push(conta);

    this.inscricao = this.contaService.save(this.contas, this.usuario).subscribe(res => {
      Swal.fire("Cadastrado com sucesso!", "", "success")
    })
  }


  downloadPdf() {
    let dataAtual = new DatePipe("pt-Br").transform(Date.now(), "yyyy-MM")
    var doc = new jsPDF('landscape');
    let pdf_pages = doc.internal.pages;
    // let margin = 35; // inches on a
    // let logoLife = new ImagensBase64()

    // doc.addImage(logoLife.imgfooter, 'JPEG', 0, 290, 210, 0)

    // doc.setFontType("normal");
    // doc.setFillColor(217, 237, 247);
    // doc.roundedRect(10, margin, 190, 8, 1, 1, "F");
    // doc.setTextColor(49, 112, 143);
    // doc.setFontSize(12);
    // doc.setFontType("bold");
    // doc.text(12, (margin += 5), "Paciente: " + this.data.ordemservico?.orcamento?.homecare?.paciente?.pessoa?.nome);

    doc.autoTable({ html: '#table', startY: 35, });
    //MES
    // (doc as any).autoTable({
    //   body: [[`Situação: ${this.data.situacao ? this.data.situacao : 'Pendente'}`]],
    //   startY: doc.lastAutoTable.finalY + 5,
    //   margin: { left: 150 },
    //   theme: 'grid',
    //   tableWidth: 'auto',
    // });
    (doc as any).autoTable({
      body: [[`Observação: ${this.data.observacao ? this.data.observacao : ''}`]],
      startY: doc.lastAutoTable.finalY + 5,
      // margin: { left: 150 },
      theme: 'grid',
      tableWidth: 'auto',
    });
    for (let i = 1; i < pdf_pages.length; i++) {
      doc.setPage(i)
      this.pdfService.headerFooterPage(doc, i, `Relatório Medição ${this.data.ordemservico.orcamento.homecare.paciente.pessoa.nome} ${this.data.dataAtual}`, this.usuario, this.logo)
    }
    doc.save(`${dataAtual} Relatório de Medição ${this.data.ordemservico.orcamento.homecare.paciente.pessoa.nome}.pdf`);
  }
  ngOnDestroy() {
    if(this.inscricao) this.inscricao.unsubscribe();
  }
}
